export default "__VITE_ASSET__2eb01d94__"